import {
  AcCard,
  AcColumn,
  AcFormInput,
  AcNumberInput,
  AcRow,
  AcTypography,
} from '@components'
import { LABELS, WEEKDAYS_LABELS } from '@constants'
import { AcDateFromWeekAndYear, getSum } from '@helpers'
import { useBreakpoints, useStore } from '@hooks'

interface IAcOrderDayCard {
  weekDay: any
  weekIdentifier: string
  disabled?: boolean
}

export const AcOrderDayCard = ({
  weekDay,
  weekIdentifier,
  disabled = false,
}: IAcOrderDayCard) => {
  const { isMobile } = useBreakpoints()
  const { user } = useStore()

  if (!weekIdentifier) {
    return null
  }

  const [week, year] = weekIdentifier.split('-')

  const date = AcDateFromWeekAndYear(
    parseInt(week),
    parseInt(year),
    weekDay.day,
    'D MMMM',
  )

  return (
    <AcCard
      cardColor="grey-10"
      contentColor="green.main">
      <AcRow
        justifyContent="space-between"
        alignItems={isMobile ? 'flex-start' : 'center'}>
        <AcRow
          flexGrow={1}
          sx={{
            gap: isMobile ? 1 : '10rem',
            flexDirection: isMobile ? 'column' : 'row',
            alignItems: isMobile ? 'flex-start' : 'center',
          }}>
          <AcColumn
            gap={0}
            sx={{ width: '25%' }}>
            <AcTypography
              bold
              color={disabled ? 'lightgray' : 'black'}
              removePadding>
              {
                WEEKDAYS_LABELS[
                  weekDay.day.toUpperCase() as keyof typeof WEEKDAYS_LABELS
                ]
              }
            </AcTypography>
            <AcTypography
              color={disabled ? 'lightgray' : 'black'}
              removePadding>
              {date}
            </AcTypography>
          </AcColumn>
          {user.hasApp && (
            <AcTypography
              justifySelf="flex-end"
              fontSize={isMobile ? 'small' : '1rem'}
              removePadding>
              {getSum([weekDay.mix, weekDay.vegan, weekDay.vegetarian])}x{' '}
              {LABELS.SIGNED_UP.toLowerCase()}
            </AcTypography>
          )}
        </AcRow>
        <AcColumn>
          <AcFormInput
            register={weekDay.day}
            Component={
              <AcNumberInput
                variant="styled"
                disabled={disabled}
                min={0}
              />
            }
          />
        </AcColumn>
      </AcRow>
    </AcCard>
  )
}
